import { render } from "./RegisterPriceTicket.vue?vue&type=template&id=7ee6bcc3"
import script from "./RegisterPriceTicket.vue?vue&type=script&lang=js"
export * from "./RegisterPriceTicket.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__